var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCode({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "technoloies_svg",
    "data-name": "technoloies svg",
    d: "M6.351,16.592,3.909,12.407,6.351,8.223a1.631,1.631,0,0,0,0-1.5.463.463,0,0,0-.877,0L2.6,11.646a1.653,1.653,0,0,0,0,1.513l2.874,4.935a.463.463,0,0,0,.877,0,1.631,1.631,0,0,0,0-1.5Zm4.133,0,2.442-4.184L10.484,8.223a1.631,1.631,0,0,1,0-1.5.463.463,0,0,1,.877,0l2.874,4.924a1.653,1.653,0,0,1,0,1.513L11.36,18.094a.463.463,0,0,1-.877,0,1.631,1.631,0,0,1,0-1.5Z",
    transform: "translate(-2.417 -6.408)",
    fill: "#334253"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.3d231987296284e21281cd920e6950a0.svg";
export { ForwardRef as ReactComponent };